
export default {
  // eslint-disable-next-line vue/component-definition-name-casing
  name: 'v-custom-mask',
  // eslint-disable-next-line vue/require-prop-types
  props: ['type', 'value', 'obj'],
  data() {
    return {
      userInput: '',
    }
  },
  computed: {
    input: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  watch: {
    input(val) {
      if (val && this.obj.schema.disabled === true) {
        this.userInput = val
      }
    },
    obj(val) {
      if (this.input && val.schema.disabled === true) {
        this.userInput = this.input
      }
    },
  },
  mounted() {
    if (this.value) {
      this.userInput = this.value
    }
  },
  methods: {
    removeInput() {
      this.$emit('input', null)
    },
  },
}
